export default class RangeIterator {
  constructor (start, stop) {
    this.value = start
    this.stop = stop
  }

  [Symbol.iterator] () { return this }

  next () {
    let value = this.value
    if (value <= this.stop) {
      this.value++
      return { done: false, value: { value } }
    } else {
      return { done: true, value: undefined }
    }
  }
}
